import React from 'react'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/scrollbar";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from 'react-router-dom';

const Testimonials = () => {
    return (
        <>
            {/* Testimonial */}
            <section className="testimonial-three">
                <div className="container">
                    <div className="testimonial-pattern">
                        <ImageWithBasePath
                            className="pattern-left img-fluid"
                            alt="Img"
                            src="assets/img/bg/pattern-05.svg"
                        />
                    </div>
                    <div className="testimonial-three-content">
                        <div className="row align-items-center row-gap-4">
                            <div className="col-xl-6 col-lg-12 col-md-12" data-aos="fade-down">
                                <div className="become-content">
                                    <h2 className="aos-init aos-animate">They Trusted us</h2>
                                    <h4 className="aos-init aos-animate">
                                        We are very happy because we have happy customers
                                    </h4>
                                </div>
                                {/* View all Testimonail */}
                                <Link
                                    to="#"
                                    className="btn btn-white aos-init aos-animate"
                                    data-aos="fade-up"
                                >
                                    Join Our Community
                                </Link>
                                {/* View all Testimonail */}
                            </div>
                            <div className="col-xl-6 col-lg-12 col-md-12" data-aos="fade-down">
                                <div className="swiper-testimonial-three">
                                    <Swiper effect="coverflow"
                                        loop={false}
                                        direction='horizontal'
                                        grabCursor={true}
                                        centeredSlides={true}
                                        slidesPerView="auto"
                                        initialSlide={2}
                                        speed={400}
                                        navigation={{
                                            prevEl: ".slide-prev-btn",
                                            nextEl: ".slide-next-btn",
                                        }}
                                        pagination={{ el: ".swiper-pagination", clickable: true }}
                                        coverflowEffect={{
                                            rotate: 0,
                                            stretch: 0,
                                            depth: 100,
                                            modifier: 10,
                                            slideShadows: true,
                                        }}
                                        modules={[EffectCoverflow, Navigation, Pagination]}
                                        className="swiper-wrapper">

                                        <SwiperSlide >
                                            <div className="swiper-slide">
                                                <div className="testimonial-item-five">
                                                    <div className="testimonial-quote">
                                                        <ImageWithBasePath
                                                            className="quote img-fluid"
                                                            alt="Img"
                                                            src="assets/img/bg/quote.svg"
                                                        />
                                                    </div>
                                                    <div className="testimonial-content">
                                                        <p>
                                                            The AI-powered platform gives us confidence that once we find the right study options, there's a high chance of student acceptance. It streamlines our search and increases success with every application
                                                        </p>
                                                    </div>
                                                    <div className="testimonial-users">
                                                        <div className="imgbx">
                                                            <ImageWithBasePath
                                                                className="img-fluid"
                                                                alt="Img"
                                                                src="assets/img/user/user-01.jpg"
                                                            />
                                                        </div>
                                                        <div className="d-block">
                                                            <h6>— Linda R.</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>


                                        <SwiperSlide>
                                            <div className="swiper-slide">
                                                <div className="testimonial-item-five">
                                                    <div className="testimonial-quote">
                                                        <ImageWithBasePath
                                                            className="quote img-fluid"
                                                            alt="Img"
                                                            src="assets/img/bg/quote.svg"
                                                        />
                                                    </div>
                                                    <div className="testimonial-content">
                                                        <p>
                                                            This platform has helped me expand my student reach and offer a wider range of institutions. The built-in eligibility assessments give both me and my students peace of mind throughout the process.
                                                        </p>
                                                    </div>
                                                    <div className="testimonial-users">
                                                        <div className="imgbx">
                                                            <ImageWithBasePath
                                                                className=""
                                                                alt="Img"
                                                                src="assets/img/user/user-02.jpg"
                                                            />
                                                        </div>
                                                        <div className="d-block">
                                                            <h6>— Tom S.</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>

                                        <SwiperSlide>
                                            {/* Swiper Slide */}
                                            <div className="swiper-slide">
                                                <div className="testimonial-item-five">
                                                    <div className="testimonial-quote">
                                                        <ImageWithBasePath
                                                            className="quote img-fluid"
                                                            alt="Img"
                                                            src="assets/img/bg/quote.svg"
                                                        />
                                                    </div>
                                                    <div className="testimonial-content">
                                                        <p>
                                                            Using this platform has transformed how I connect with students worldwide. It offers more program options and simplifies eligibility checks, making the entire recruitment process smoother and more reliable for everyone involved.
                                                        </p>
                                                    </div>
                                                    <div className="testimonial-users">
                                                        <div className="imgbx">
                                                            <ImageWithBasePath
                                                                className=""
                                                                alt="Img"
                                                                src="assets/img/user/user-03.jpg"
                                                            />
                                                        </div>
                                                        <div className="d-block">
                                                            <h6>— Sabrina M.</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* /Swiper Slide */}
                                        </SwiperSlide>
                                    </Swiper>
                                    <div className="testimonial-bottom-nav">
                                        <div className="slide-next-btn testimonial-next-pre">
                                            <i className="fas fa-arrow-left" />
                                        </div>
                                        <div className="slide-prev-btn testimonial-next-pre">
                                            <i className="fas fa-arrow-right" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/*/Testimonial */}
        </>

    )
}

export default Testimonials
